module.exports = __webpack_public_path__ + "static/27-bd0d720ee19baa076c32f538e864ae6e.jpg";